import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {ReportGeneratorService} from '../../../services/report-generator.service';
import { AuthTokenService } from '../../../services/auth-token.service';
import {invitationLetterStaticTemplate} from '../../../../assets/static/invitation-letter-static-template';
import {CustomStyleService} from '../../../services/custom-style.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'custom-report-view-modal',
    templateUrl: './custom-report-view-modal.component.html',
    styleUrls: ['./custom-report-view-modal.component.scss']
})
export class CustomReportViewModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    templateText = '';
    originalMessage = '';
    reportTemplate = null;
    placeholders = [];
    reportTemplates = [];
    showSpinner = false;
    save = false;
    loadingCorporations = false;
    templateName = '';
    corporations = [];
    corporation = null;
    orientation = 'Portrait';

    constructor(
        public api: ApiClientService,
        public reportGeneratorService: ReportGeneratorService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private http: Http,
        private authTokenService: AuthTokenService,
        private customStyleService: CustomStyleService
    ) {}

    ngOnInit() {
        this.getReportTemplates();
        this.getCorporations();
        this.placeholders = this.reportGeneratorService.templateInTemplateModal.reportTemplate.placeholders;
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.reportGeneratorService.showCustomReportViewModal = false;
                    this.reportGeneratorService.templateInTemplateModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.reportGeneratorService.showCustomReportViewModal = false;
            this.reportGeneratorService.templateInTemplateModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm, preview) {
        const reportTemplate = form.value.reportTemplate;

        if (!reportTemplate && reportTemplate !== 0) { toastr.warning('Report template is not set.'); return; }
        if (!this.templateText) { toastr.warning('Template must not be empty.'); return; }
        if (this.save && (!this.corporation && this.corporations.length > 1)) { toastr.warning('Corporation must be selected.'); return; }
        const data = {
            rowTemplate: this.templateText,
            addPageBreaks: true,
            options: {
                orientation: this.orientation
            }
        };
        this.disabledSubmit = true;

        const demoFlag = `${preview ? '?demo=1' : ''}`;
        const token   = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        const url =  `${this.reportGeneratorService.templateInTemplateModal.links.pdf}.json${demoFlag}`;
        this.http.post(url, data, options).map((response: Response) => response.json()).subscribe(
            res => {
                const pdfWindow = window.open('');
                const styling = '<style>body{margin: 0;} iframe{border: none; width: 100%; height: 100%}</style>';
                pdfWindow.document.write(styling + `<iframe src=\'data:application/pdf;base64,${res.file}\'></iframe>`);
                if(!preview) {
                    if (this.save) {
                        const corp = parseInt(this.corporations.length > 1 ? this.corporation : this.corporations[0].id);
                        const htmlTemplate = {
                            name: this.templateName,
                            corporationNumberId: !this.reportTemplate || this.reportTemplate == 0.1 ? corp : undefined,
                            reportTemplate: !this.reportTemplate || this.reportTemplate == 0.1 ? this.reportGeneratorService.templateInTemplateModal.reportTemplate.id : undefined,
                            rowTemplate: this.templateText,
                            addPageBreaks: true
                        };
                        const url = `/v1/html_templates${this.reportTemplate ? ('/' + this.reportTemplate) : ''}`;
                        this.api[this.reportTemplate ? 'patch' : 'post']('domainReportGenerator', url, htmlTemplate).subscribe(
                            res => this.updateView('Custom view was saved successfully'),
                            error => this.api.errorHandler('Failed to save view')
                        );
                    } else
                        this.updateView('Custom report view was downloaded successfully.');
                }
            },
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Email template has failed to update');
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        if(this.save)
            this.reportGeneratorService.getData();
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote(enabled) {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => this.templateText = contents
            },
            toolbar: enabled ? [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr', 'picture']],
                ['help', ['help']],
                ['view', ['codeview']],
            ] : [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.templateText).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });

        if(!enabled)
            summernote.summernote('disable');
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote(true), 300);
    }

    reportTemplateSelect(arr: Array<any>) {
        return arr.map(template => ({value: template.id, optionText: template.name}));
    }
    changeTemplate(event): void {
        this.templateName = '';
        this.reportTemplate = event;
        if(event != 0 && event != 0.1) {
            const templateObject = this.reportTemplates.find( template => template.id == event);
            if(templateObject) {
                this.templateText = templateObject.rowTemplate;
                this.templateName = templateObject.name;
                this.corporation = templateObject.corporationNumberId;
                document.getElementsByClassName('note-editable panel-body')[0].innerHTML = templateObject.rowTemplate;
            }
        } else if(event == 0.1) {
            const customizedTemplate = invitationLetterStaticTemplate.replace('||image-path||', this.customStyleService.obj.logo);
            this.templateText = customizedTemplate;
            this.templateName = 'Invitation Letter';
            document.getElementsByClassName('note-editable panel-body')[0].innerHTML = customizedTemplate;
        }
    }

    getReportTemplates() {
        this.showSpinner = true;
        const url = `/v1/html_templates/by_report/${this.reportGeneratorService.templateInTemplateModal.id}`;
        this.api.get('domainReportGenerator', url).subscribe(
            res => {
                this.reportTemplates = [];
                const body = JSON.parse(res._body);
                this.reportTemplates = body.entities || [];
                this.reportTemplates.push({id: 0.1, name: 'Invitation Letter'});
                this.reportTemplates.push({id: 0, name: 'Other'});
                this.showSpinner = false;
                this.initSummernote(true);
            },
            error => {
                this.showSpinner = false;
                this.reportTemplates = [];
                this.reportTemplates.push({id: 0.1, name: 'Invitation Letter'});
                this.reportTemplates.push({id: 0, name: 'Other'});
                this.api.errorHandler(error, 'Failed to get Report Templates');
            }
        );
    }

    hideEditPanelSetter() {
        this.showEditPanel = false;
        setTimeout( () => this.initSummernote(false), 300);
    }

    getCorporations(): void {
        this.loadingCorporations = true;
        const url = `/v1/corporation_number.json?per-page=10000&order-by=name|asc`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.loadingCorporations = false;
                this.corporations = JSON.parse(res._body).entities || [];
            },
            error => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/custom-report-view-modal/custom-report-view-modal.component.ts